// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1dq4X","footer":"ModalFilter_footer__3Hk1g"};